import React, { useState, useRef } from "react";

import "./dishEditor.css";

const DishEditor = ({
  dish,
  dishes,
  isFromCopy,
  originalDishId,
  isFromUpdate,
  handleCreateDish,
  removeOriginalIdFromCopiesArrayCallback,
  handleUpdateDish,
  closeEditorFormCallBack
}) => {
  const [dishInEdit, setDishInEdit] = useState({ ...dish });
  const [isFileInputEmpty, setIsFileInputEmpty] = useState(true);

  let fileInput = useRef(null);

  // handle input changes
  const handleNameInputChange = (e) => {
    const workingDishInEdit = { ...dishInEdit };

    workingDishInEdit.name = e.target.value;

    setDishInEdit({ ...workingDishInEdit });
  };

  const handleCategoryInputChange = (e) => {
    const workingDishInEdit = { ...dishInEdit };

    workingDishInEdit.category = e.target.value;

    setDishInEdit({ ...workingDishInEdit });
  };

  const handleSubcategoryInputChange = (e) => {
    const workingDishInEdit = { ...dishInEdit };

    workingDishInEdit.subcategory = e.target.value;

    setDishInEdit({ ...workingDishInEdit });
  };

  const handleServingInputChange = (e) => {
    const workingDishInEdit = { ...dishInEdit };

    workingDishInEdit.serving = e.target.value;

    setDishInEdit({ ...workingDishInEdit });
  };

  const hanldeMacrosInputChange = (e) => {
    const workingDishInEdit = { ...dishInEdit };

    workingDishInEdit.macros = e.target.value;

    setDishInEdit({ ...workingDishInEdit });
  };

  const handleExpirationInputChange = (e) => {
    const workingDishInEdit = { ...dishInEdit };

    workingDishInEdit.expiration = e.target.value;

    setDishInEdit({ ...workingDishInEdit });
  };

  const handlePriceInputChange = (e) => {
    const workingDishInEdit = { ...dishInEdit };

    workingDishInEdit.price = e.target.value;

    setDishInEdit({ ...workingDishInEdit });
  };

  const handleCaloriesChange = (e) => {
    const workingDishInEdit = { ...dishInEdit };

    workingDishInEdit.calories = e.target.value;

    setDishInEdit({ ...workingDishInEdit });
  };

  const handleCompositionChange = (e) => {
    const workingDishInEdit = { ...dishInEdit };

    workingDishInEdit.composition = e.target.value;

    setDishInEdit({ ...workingDishInEdit });
  };

  const handleDescriptionInputChange = (e) => {
    const workingDishInEdit = { ...dishInEdit };

    workingDishInEdit.description = e.target.value;

    setDishInEdit({ ...workingDishInEdit });
  };

  // handle pictures uploads and removals
  const handleUploadPicture = (e) => {
    if (e) {
      e.preventDefault();
    }

    let reader = new FileReader();
    let file = fileInput.current.files[0];

    reader.onloadend = function () {
      const workingDishInEdit = { ...dishInEdit };

      workingDishInEdit.pictureURL = reader.result;

      setDishInEdit({ ...workingDishInEdit });

      fileInput.current.value = "";
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleDeletePicture = () => {
    const workingDishInEdit = { ...dishInEdit };

    workingDishInEdit.pictureURL = "";

    setDishInEdit({ ...workingDishInEdit });
  };

  const handleChangePicture = (e, pictureURL) => {
    e.preventDefault();

    try {
      handleDeletePicture(pictureURL);

      handleUploadPicture(null);
    } catch (err) {
      console.log(err);
    }
  };

  const handleFileInputChange = (e) => {
    setIsFileInputEmpty(false);
  };

  return (
    <div className="dishComponent">
      <div className="dishComponent__dishBodyDiv">
        <div className="dishBodyDiv__nameDiv">
          <h4>name</h4>
          <input
            type="text"
            name="name"
            id="name"
            onChange={handleNameInputChange}
            value={dishInEdit.name}
          />
        </div>
        <div className="dishBodyDiv__categoryDiv">
          <h4>category</h4>
          <input
            type="text"
            name="category"
            id="category"
            list="categoriesList"
            onChange={handleCategoryInputChange}
            value={dishInEdit.category}
          />
          <datalist id="categoriesList">
            {dishes
              .reduce(
                (acc, x) =>
                  acc.concat(
                    acc.find((y) => y.category === x.category) ? [] : [x]
                  ),
                []
              )
              .map((category) => (
                <option key={category.category} value={category.category} />
              ))}
          </datalist>
        </div>
        <div className="dishBodyDiv__subcategoryDiv">
          <h4>subcategory</h4>
          <input
            type="text"
            name="subcategory"
            id="subcategory"
            list="subcategoriesList"
            onChange={handleSubcategoryInputChange}
            value={dishInEdit.subcategory}
          />
          <datalist id="subcategoriesList">
            {dishes
              .reduce(
                (acc, x) =>
                  acc.concat(
                    acc.find((y) => y.subcategory === x.subcategory) ? [] : [x]
                  ),
                []
              )
              .map((subcategory) => (
                <option
                  key={subcategory.subcategory}
                  value={subcategory.subcategory}
                />
              ))}
          </datalist>
        </div>
        <div className="dishBodyDiv__servingDiv">
          <h4>serving size</h4>
          <input
            type="text"
            name="serving"
            id="serving"
            value={dishInEdit.serving}
            onChange={handleServingInputChange}
          />
        </div>
        <div className="dishBodyDiv__macrosDiv">
          <h4>macros</h4>
          <input
            type="text"
            name="macros"
            id="macros"
            value={dishInEdit.macros}
            onChange={hanldeMacrosInputChange}
          />
        </div>
        <div className="dishBodyDiv__expirationDiv">
          <h4>expiration time</h4>
          <input
            type="text"
            name="expiration"
            id="expiration"
            value={dishInEdit.expiration}
            onChange={handleExpirationInputChange}
          />
        </div>
        <div className="dishBodyDiv__priceDiv">
          <h4>price</h4>
          <input
            type="text"
            name="price"
            id="price"
            value={dishInEdit.price}
            onChange={handlePriceInputChange}
          />
        </div>
        <div className="dishBodyDiv__caloriesDiv">
          <h4>calories</h4>
          <input
            type="text"
            name="calories"
            id="calories"
            value={dishInEdit.calories}
            onChange={handleCaloriesChange}
          />
        </div>
        <div className="dishBodyDiv__compositionDiv">
          <h4>composition</h4>
          <textarea
            style={{ fontFamily: "Arial" }}
            rows="5"
            cols="33"
            name="composition"
            id="composition"
            value={dishInEdit.composition}
            onChange={handleCompositionChange}
          />
        </div>
        <div className="dishBodyDiv__descriptionDiv">
          <h4>description</h4>
          <textarea
            style={{ fontFamily: "Arial" }}
            rows="5"
            cols="33"
            name="description"
            id="description"
            value={dishInEdit.description}
            onChange={handleDescriptionInputChange}
          />
        </div>
        {!isFromCopy && dish._id ? (
          <div className="dishBodyDiv__pictureDiv">
            {!dishInEdit.pictureURL ? null : (
              <div className="pictureDiv__uploadedPictureThumbnail">
                <img
                  src={dishInEdit.pictureURL}
                  alt="dish"
                  style={{ width: "30%" }}
                />
                <button
                  className="pictureDiv__deletePictureBtn"
                  onClick={() => handleDeletePicture(dishInEdit.pictureURL)}
                >
                  <svg
                    title="delete picture"
                    className="bi bi-x-circle-fill"
                    width="1.5em"
                    height="1.5em"
                    viewBox="0 0 20 20"
                    fill="var(--btn-border-color-red)"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM7.354 6.646L10 9.293l2.646-2.647a.5.5 0 01.708.708L10.707 10l2.647 2.646a.5.5 0 01-.708.708L10 10.707l-2.646 2.647a.5.5 0 01-.708-.708L9.293 10 6.646 7.354a.5.5 0 11.708-.708z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            )}
            <div className="pictureDiv__uploadPicture">
              <form
                onSubmit={
                  !dishInEdit.pictureURL
                    ? (e) => handleUploadPicture(e)
                    : (e) => handleChangePicture(e, dishInEdit.pictureURL)
                }
              >
                <label
                  htmlFor={`single_upload${dishInEdit.name}`}
                  className="uploadPicture__chooseDishPicture"
                >
                  <input
                    ref={fileInput}
                    type="file"
                    name="single_upload"
                    id={`single_upload${dishInEdit.name}`}
                    onChange={(e) => handleFileInputChange(e)}
                  />
                  CHOOSE PICTURE
                  <br />
                  <svg
                    className="bi bi-folder-fill"
                    width="1.5em"
                    height="1.5em"
                    viewBox="0 0 20 20"
                    fill="white"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.828 5h3.982a2 2 0 011.992 2.181l-.637 7A2 2 0 0115.174 16H4.826a2 2 0 01-1.991-1.819l-.637-7a1.99 1.99 0 01.342-1.31L2.5 5a2 2 0 012-2h3.672a2 2 0 011.414.586l.828.828A2 2 0 0011.828 5zm-8.322.12C3.72 5.042 3.95 5 4.19 5h5.396l-.707-.707A1 1 0 008.172 4H4.5a1 1 0 00-1 .981l.006.139z"
                      clipRule="evenodd"
                    />
                  </svg>
                </label>
                <button
                  type="submit"
                  className="uploadPicture__uploadDishPictureBtn"
                  disabled={isFileInputEmpty ? true : false}
                >
                  {!dishInEdit.pictureURL ? "UPLOAD PICTURE" : "CHANGE PICTURE"}
                </button>
              </form>
            </div>
          </div>
        ) : null}
      </div>
      <div className="dishEditor__controlsDiv">
        <button
          className="controlsDiv__saveDishBtn"
          onClick={
            !isFromUpdate
              ? !isFromCopy
                ? () => {
                    handleCreateDish(dishInEdit);
                    setDishInEdit({ ...dish });
                  }
                : () => {
                    handleCreateDish(dishInEdit);
                    removeOriginalIdFromCopiesArrayCallback(originalDishId);
                  }
              : () => {
                  handleUpdateDish(dish._id, dishInEdit);
                  closeEditorFormCallBack();
                }
          }
        >
          SAVE
        </button>
        <button
          className="controlsDiv__cancelDishBtn"
          onClick={
            !isFromUpdate
              ? !isFromCopy
                ? () => setDishInEdit({ ...dish })
                : () => removeOriginalIdFromCopiesArrayCallback(originalDishId)
              : () => closeEditorFormCallBack()
          }
        >
          CANCEL
        </button>
      </div>
    </div>
  );
};

export default DishEditor;
